import { render, staticRenderFns } from "./RouteInstructions.vue?vue&type=template&id=545a709e&scoped=true&"
import script from "./RouteInstructions.vue?vue&type=script&lang=js&"
export * from "./RouteInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a709e",
  null
  
)

export default component.exports